import React, { useCallback } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { CommonStyles } from '../../styles';
import TitleWithOption from './TitleWithOption';
import ExpenseFormItem, { ExpenseFormInput } from '../ExpenseWidget/ExpenseFormItem';
import { widgetStyles } from '../../styles/theme';
import { pickImage } from '../../utils/image.utils';

const SpeakerWidget = ({ speaker, onRemove, onUpdate }) => {
  const dispatch = useCallback(
    ({ type, value }) => {
      onUpdate({
        id: speaker.id,
        type,
        value,
      });
    },
    [onUpdate, speaker.id]
  );

  return (
    <View style={CommonStyles.mb3}>
      <TitleWithOption onRemovePress={onRemove} />
      <View style={widgetStyles.widget}>
        <ExpenseFormInput
          label="Speaker Name"
          value={speaker.name}
          onChangeText={(value) => dispatch({ type: 'name', value })}
          icon={!speaker.name && 'person'}
        />
        <ExpenseFormInput
          label="Speaker Title"
          value={speaker.title}
          onChangeText={(value) => dispatch({ type: 'title', value })}
          icon={!speaker.title && 'passport'}
          style={widgetStyles.topBorder}
        />
        <ExpenseFormInput
          label="Speaker Bio"
          value={speaker.bio}
          onChangeText={(value) => dispatch({ type: 'bio', value })}
          icon={!speaker.bio && 'message'}
          style={widgetStyles.topBorder}
        />
        <TouchableOpacity
          onPress={() => pickImage((result) => dispatch({ type: 'image', value: result.uri }))}
        >
          <ExpenseFormItem
            label="Speaker's Image"
            value={speaker.image ? speaker.image.substring(0, 20) : null}
            icon={!speaker.image && 'image'}
            style={widgetStyles.topBorder}
          />
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default SpeakerWidget;
